<template>
	<v-dialog v-model="dialog" persistent max-width="600px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" class="text-lowercase mr-8" dark small v-on="on">
				{{ 'add channel' | localize }}
			</v-btn>
		</template>
		<v-card v-if="isLoaded">
			<v-card-title class="subtitle-1 pt-6">
				{{ 'Parameters of the new chanel' | localize }}
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="black--text">
				<v-container grid-list-md>
					<v-form ref="form" v-model="valid" lazy-validation @submit.prevent>
						<v-row>
							<v-col cols="12" md="8" sm="6">
								<v-select dense v-model="type"
									no-data-text="You can't add a new channel :("
									color="secondary"
									:items="types" 
									tem-text="text" 
									item-value="value"
									item-color="secondary" 
									:label="'Channel type' | localize" 
									@change="onceMore"
									:rules="[rules.required]">
								</v-select>
							</v-col>

							<v-col cols="12" md="8" sm="6">
								<v-select dense 
									:multiple="multiple"
									v-model="trademark"
									:items="teamTrademarks" 
									item-text="name"
									item-value="name"
									color="secondary" 
									item-color="secondary" 
									:label="'Trademarks' | localize"
									@change="onceMore"
									:rules="[rules.not_empty]">
								</v-select>
							</v-col>
							<v-col cols="12" md="4" sm="6">
								<v-text-field dense 
									color="secondary" 
									:label="'Stores' | localize" 
									v-model.number="stores" 
									name="stores"
									type="text" 
									:readonly="readonly"
									:rules="[rules.number]"
									@change="onceMore()">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="8">
								<v-text-field dense 
									color="secondary" 
									:label="'Channel name' | localize" 
									v-model="name" name="name" readonly
									type="text" :rules="[rules.required]">
								</v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-container>
				<v-row v-if="error" justify="center" class="text-pre-wrap mx-2 error--text">{{'Error' | localize }} => {{ error }} &#128533;</v-row>
				<v-row class="text-start text-pre-wrap mx-2">{{ message }}</v-row>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="secondary" text class="text-capitalize"
					:disabled="!valid || Boolean(error)"
					@click="calculate">
					{{ 'Calculate' | localize }}
				</v-btn>
				<v-btn color="secondary" text class="text-capitalize" 
					:disabled="!calculating || Boolean(error)"
					@click="addChannel">
					{{ 'Save' | localize }}
				</v-btn>
				<v-btn color="secondary" text class="text-capitalize" 
					@click="closeDialog">
					{{ 'Close' | localize }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { retailInvestments, operationalCosts, getCoverage } from '../../../functions/retail';
import { localeNumber } from '../../../functions/common.js';
import localizeFilter from '../../../filters/localize.filter.js';

export default {
	data() {
		return {
			dialog: false,
			valid: false,
			message: '',
			error: '',
			calculating: false,
			rules: {
				required: v => !!v || localizeFilter('required field'),
				number: v => /^[+]?[0-9]/.test(v) || localizeFilter('its expected number'),
				not_empty: v => v.length > 0 || localizeFilter('select min 1 item'),
			},
			stores: 1,
			type: null,
			trademark: [],
			investments: null,
			operational: null,
			peak_market_coverage: 0,
			isLoaded: false,
		}
	},
	computed: {
		loading() {
			return this.$store.getters.loading;
		},
		locale() {
			return this.$store.getters.locale;
		},
		user() {
			return this.$store.getters.user;
		},
		game() {
			return this.$store.getters.game;
		},
		team() {
			return this.$store.getters.team;
		},
		trademarks() {
			return this.$store.getters.trademarks;
		},
		finances () {
			return this.$store.getters.finances;
		},
		channels() {
			return this.$store.getters.channels;
		},
		readonly() {
			if (parseInt(this.type) == 1) return true
			return false
		},
		teamTrademarks() {
			let res = [];
			if (this.team) {
				const arr = [];
				this.team?.products.map(prod => {
					const inArr = arr.find(it => it === prod.trademarkId)
					if (!inArr) {
						arr.push(prod.trademarkId)
					}
				})
				res = this.trademarks.filter(it => arr.indexOf(it.id) !== -1)
			}
			return res
		},
		name() {
			let name = ''
			if (this.team && this.type && this.trademark?.length) {
				switch (this.type) {
					case 1: name = this.team.name.split('_')[0] + ' online';
						break;
					case 2: name = this.team.name.split('_')[0] + ' store';
						break;
					case 3: name = this.trademark + ' store';
				}
			}
			return name;
		},
		multiple() {
			if (this.type == 3) {
				return false
			}
			return true
		},
		types() {
			const types = [];
			const trm_channels = this.channels?.filter(chan => chan.type == 3);
			
			if (!this.channels?.find(chan => chan.type == 1)) {
				types.push({ text: 'online store', value: 1 });
			}
			if (!this.channels?.find(chan => chan.type == 2)) {
				types.push({ text: 'team brick&mortar store', value: 2 });
			}
			if (!trm_channels || trm_channels?.length < this.teamTrademarks?.length) {
				types.push({ text: 'trademark brick&mortar store', value: 3 });
			}
			console.log(types)
			return types;
		}
	},
	watch: {
		type() {
			this.trademark = [];
		}
	},
	methods: {
		onceMore() {
			this.calculating = false;
			this.message = '';
			this.error = '';
		},
		calculate() {
			if (this.$refs.form.validate()) {

				//check the name
				const chan_exist = this.channels.find(ch => ch.name == this.name);
				
				if (chan_exist) {
					
					this.error = `retail channel: "${ this.name }" already exists`;
					
					if (this.locale == 'ro-RO') {
						this.error = `canal de vânzare cu amănuntul: "${ this.name }" există deja`
					}
					else if (this.locale == 'ru-RU') {
						this.error = `канал продаж: "${ this.name }" уже существует`
					}
					return this.error
				}

				//checking all brands plus
                if (this.type == 1 || this.type == 2) {
                    if (this.trademark.length !== this.teamTrademarks.length) {
                        return this.error = localizeFilter('You must add all trademarks of the team!');
                    }
                }

				this.investments = retailInvestments(this.type, this.stores);
				this.operational = operationalCosts(this.type, this.stores);
				this.peak_market_coverage = getCoverage(this.type);

				/* console.log(` growth finances: ${this.finances.growth_finances}`) */

				if (this.investments > this.finances.growth_finances) {

					this.error = localizeFilter(`You don't have enough money to create the store`);
				}
				else {
					/* console.log(this.locale);*/
					if (this.locale == 'ro-RO') {
						this.message = `Vă rugăm să luați notă:

						Costurile de investiție = $${localeNumber(this.investments, this.locale)}
						Costuri operaționale = $${localeNumber(this.operational, this.locale)}
						Acoperirea maximă a pieței = ${localeNumber(this.peak_market_coverage * this.stores, this.locale)}
						--------------------------------------------------------------
					Dacă sunteți de acord, apăsați butonul "Salvare", altfel - apăsați "Închide"`
					} 
					else if (this.locale == 'ru-RU') {
						this.message = `Пожалуйста, обратите внимание:

						Инвестиции = $${localeNumber(this.investments, this.locale)}
						Операционные расходы = $${localeNumber(this.operational, this.locale)}
						Максимальный охват рынка = ${localeNumber(this.peak_market_coverage * this.stores, this.locale)}
						-------------------------------------------------------
					Согласны? Нажмите кнопку "Сохранить", иначе — кнопку "Закрыть"`
					}
					else {
						this.message = `Please take note:

						Investment costs = $${localeNumber(this.investments, this.locale)}
						Operational costs = $${localeNumber(this.operational, this.locale)}
						Peak market coverage = ${localeNumber(this.peak_market_coverage * this.stores, this.locale)}
						---------------------------------------------------------
					If you agree, press the button "Save", else - press "Close"`
					}

				}
				
				this.calculating = true;
			}
		},
		async addChannel() {
			
			let trademarks = [];
			
			typeof this.trademark == 'string' ?
				trademarks.push(this.trademark) :
				trademarks = this.trademark;

			const chan = {
				gameId: this.game.id,
				round: this.game.round,
				register_round: this.game.round,
				teamId: this.team.id,
				name: this.name,
				stores: this.stores,
				type: this.type,
				investment_costs: this.investments,
				operational_costs: this.operational,
				peak_market_coverage: this.peak_market_coverage,
				trademarks: trademarks,
				team: this.team
			}
			//console.log(chan)
			await this.$store.dispatch('addChannel', chan)
			this.closeDialog();
		},
		closeDialog() {
			//reset
			this.dialog = false
			this.calculating = false
			this.message = ''
			this.error = ''
			
			this.stores = 1;
			this.type = null;
			this.trademark = [];
			this.investments = null;
			this.operational = null;
			this.peak_market_coverage = 0;

		}
	},
	/* components: { Loader }, */
	async created() {
		if (this.game && this.team) {
			
			const params = {
				gameId: this.game.id,
				round: this.game.round,
				teamId: this.team.id,
			}

			if (this.finances == null) {
				try {
					await this.$store.dispatch('fetchTeamFinances', params);
					console.log('Loading finances from addChannel...')
				}
				catch (error) {
					await this.$store.dispatch('setError', error.message)
				}
			}
			
			this.isLoaded = true;
		}
	}
}
</script>
